import { BasePermissionV2 } from '@qmu/common/dto/userGroupsDto';
import { isObject } from 'lodash';

export const hasAnyPermission = (obj: BasePermissionV2) => {
  if (!isObject(obj)) return false;
  const objKey = Object.keys(obj);
  return objKey.some(key => obj[key] === true);
};
